import { render, staticRenderFns } from "./PlayVideo.vue?vue&type=template&id=1f42dee5&scoped=true"
import script from "./PlayVideo.vue?vue&type=script&lang=js"
export * from "./PlayVideo.vue?vue&type=script&lang=js"
import style0 from "./PlayVideo.vue?vue&type=style&index=0&id=1f42dee5&prod&scoped=true&lang=less"
import style1 from "./PlayVideo.vue?vue&type=style&index=1&id=1f42dee5&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../../空降-sp-弯弯介绍的/kj-德语-源码/node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f42dee5",
  null
  
)

export default component.exports